import React, { useState } from 'react';

import { Accordion, Button } from '@iwoca/orion';

import styles from './AccessUsers.module.css';
import { AccessLevelsTable } from './components/AccessLevelsTable/AccessLevelsTable';
import { AccessUserForm } from './components/AccessUserDetailsForm/AccessUserDetails';
import { AccessUsersTable } from './components/AccessUsersTable/AccessUsersTable';
import {
  useGetSellerAccessUsers,
  useGetStateByStateKey,
} from '../../api/lending/lapiHooks';
import { SellerNavBar } from '../../components/NavBars/SellerNavBar/SellerNavBar';
import { PageTemplate } from '../../components/PageTemplate/PageTemplate';
import { useSellerDetails } from '../Dashboard/hooks/useSellerDetails';

export const AccessUsers = () => {
  const applicantDetails = useSellerDetails();
  const [showForm, setShowForm] = useState(false);
  const { refetchAccessUsers } = useGetSellerAccessUsers();
  const { state: customerState } = useGetStateByStateKey();

  const showAccessUserForm = () => {
    setShowForm(!showForm);
  };

  const closeFormAndRefreshTable = async () => {
    showAccessUserForm();
    await refetchAccessUsers();
  };

  const fullName = `${applicantDetails?.firstName} ${applicantDetails?.lastName}`;

  const loggedInCustomerEmailAddress =
    customerState?.application?.people?.[0].emails?.[0].email;

  return (
    <PageTemplate NavBar={() => <SellerNavBar />}>
      <div className={styles.page}>
        <div className={styles.content}>
          <div className={styles.headerContainer}>
            <div>
              <div className={styles.pageHeader}>
                {applicantDetails?.companyName || ''} users
              </div>
              <div className={styles.subheading}>
                Owner: {fullName} | {loggedInCustomerEmailAddress}
              </div>
              <div className={styles.introduction}>
                These are the users that have access to the iwocaPay seller
                dashboard.
              </div>
            </div>
          </div>
          <div className={styles.accordionWrapper}>
            <Accordion
              small={true}
              title="What are the different access levels?"
              variant="primary"
              frame={false}
              iconPosition="hug"
              className={styles.accordionBackground}
            >
              <AccessLevelsTable />
            </Accordion>
          </div>
          <div className={styles.tableWrapper}>
            <AccessUsersTable />
          </div>
          {!showForm && (
            <>
              <Button onClick={showAccessUserForm}>Add a new user</Button>
              <div className={styles.buttonDescriptionContainer}>
                <p className={styles.buttonDescription}>
                  Any users you add will be sent a email to confirm their access
                  and set up their account.
                </p>
              </div>
            </>
          )}
          {showForm && (
            <AccessUserForm
              onSuccess={closeFormAndRefreshTable}
              onCancel={showAccessUserForm}
            />
          )}
        </div>
      </div>
    </PageTemplate>
  );
};
